(function () {
    var controllerId = 'clinic.views.hospital.fglRequest';
    var app = angular.module('app');
    app.controller(controllerId, ['$scope', '$stateParams', '$state', '$timeout', 'abp.services.app.hospitalPanelServiceRequest', 'abp.services.app.commonLookup', 'moment', controller]);

    function controller($scope, $stateParams, $state, $timeout, hospitalPanelServiceRequestSvc, commonLookupSvc, moment) {
        var vm = this;
        vm.loading = 0;
        vm.saving = 0;
        vm.exporting = 0;
        vm.letterNumber = $stateParams.letterNumber;
        vm.currencyCode = abp.setting.get('Hms.General.CurrencyCode');

        // HM-11335: the BE holds a hub GL's FGL while the Hub has not yet confirmed the hospital's query
        // reply. It reports that as a normal result (isReplyPendingHubConfirmation), not as an error, so
        // ABP's own error handling (401 re-login and friends) stays untouched. Retry quietly behind the
        // saving spinner for up to the limit, then offer Close / Submit again.

        var hubReplyRetryDelayMs = 2000;
        var hubReplyRetryLimitMs = 10000;
        var hubReplyRetryTimer = null;
        var isDestroyed = false;

        $scope.$on('$destroy', function () {
            isDestroyed = true;
            if (hubReplyRetryTimer) {
                $timeout.cancel(hubReplyRetryTimer);
                hubReplyRetryTimer = null;
            }
        });

        // HM-11000: gate FGL submission when a hub GL has unanswered medical queries.

        vm.hasUnansweredMedicalQueries = false;
        vm.unansweredQueryNumbers = [];
        var fglIntentKey = 'fglIntent:' + vm.letterNumber;
        vm.hasInpatientRegionalExpansion = abp.setting.getBoolean(
            'Hms.Feature.RegionalExpansionForInpatient');

        vm.activeTab = 0;
        vm.prevTab = prevTab;
        vm.nextTab = nextTab;
        vm.setActiveTab = setActiveTab;
        vm.submit = submit;
        vm.downloadDischargeForm = downloadDischargeForm;

        vm.newAttachments = [];
        vm.attachments = [];
        var fileExtensions = '|' + app.consts.fileUpload.imageExtensions.concat(app.consts.fileUpload.pdfExtensions).join('|') + '|';
        vm.uploadConfig = {
            objectType: 'InpatientFglRequestAttachment',
            itemsLimit: 5,
            accept: 'image/*,application/pdf',
            filters: [{
                name: 'fileFilter',
                fn: function (n) {
                    var t = '|' + n.type.slice(n.type.lastIndexOf('/') + 1) + '|';
                    if (fileExtensions.indexOf(t) === -1) {
                        abp.message.warn(App.localize('File_Warn_FileType'));
                        return false;
                    }
                    return true;
                }
            }, {
                name: 'sizeFilter',
                fn: function (n) {
                    var sizeLimit = 52428800;
                    if (n.size > sizeLimit) {
                        abp.message.warn(App.localize('File_Warn_XSizeLimit', sizeLimit / 1024 / 1024));
                        return false;
                    }
                    return true;
                }
            }]
        };
        var maxDate = moment([moment().year() + 5, 1, 1]);

        function init() {
            getPatientDischargeDetails();
            if (vm.hasInpatientRegionalExpansion) {
                getCurrency();
                getLanguage();
            }
            
        }

        function getPatientDischargeDetails() {
            vm.loading++;
            hospitalPanelServiceRequestSvc.getDischargePatientDetails({
                letterNumber: vm.letterNumber
            }).success(function (data) {
                vm.letter = data;

                _.each(vm.letter.documentChecklistItems, function (item) {
                    item.required = item.isMandatory;
                    item.isChecked = item.isSelected;
                });

                // HM-11000: the unanswered-query signal and pending query numbers are
                // exposed on GetDischargePatientOutput by the BE (HM-10893). When the
                // signal is true, prompt on load and disable submit.

                vm.hasUnansweredMedicalQueries = !!data.hasUnansweredMedicalQueries;
                vm.unansweredQueryNumbers = data.unansweredQueryNumbers || [];

                if (vm.hasUnansweredMedicalQueries) {
                    promptUnansweredQueries();
                }
            }).finally(function () {
                vm.loading--;
            });
        }

        function getCurrency() {
            vm.loading += 1;
                commonLookupSvc
                    .getTenantCurrencyCode()
                    .success((data) => { vm.currencyCode = data })
                    .finally(() => { vm.loading -= 1 });
        }

        function getLanguage() {
            vm.loading += 1;
            commonLookupSvc
                .getDefaultLanguageByCountryCode()
                .success((data) => { vm.language = data })
                .finally(() => { vm.loading -= 1 });
        }


        function submit() {
            if (vm.saving)
                return;

            // HM-11000: belt-and-braces client guard — re-check the loaded signal
            // before submitting (no extra server call). The BE guard (HM-10892) is
            // the authoritative staleness backstop.

            if (vm.hasUnansweredMedicalQueries) {
                promptUnansweredQueries();
                return;
            }

            var checklistItems = [];
            _.each(vm.letter.documentChecklistItems, function (item) {
                checklistItems.push({
                    text: item.text,
                    isSelected: item.isChecked,
                    isMandatory: item.required
                });
            });

            var attachments = [];
            _.each(vm.attachments, function (attachment) {
                if (!attachment.isDelete)
                    attachments.push(attachment.id);
            });

            // Build the payload as a copy. Mutating vm.letter here would flatten documentChecklistItems
            // (isChecked/required lost), so a held or failed submit would corrupt the form for the next attempt.
            var input = angular.extend({}, vm.letter, {
                dischargeDate: vm.letter.dischargeDate,
                documentChecklistItems: checklistItems,
                newAttachments: vm.newAttachments
            });

            vm.saving = true;
            submitFinalGuaranteeLetter(input, Date.now());
        }

        // HM-11335: one submission attempt. ABP's default error handling stays on; only the "reply pending"
        // result is special-cased, and only while the page is still alive.

        function submitFinalGuaranteeLetter(input, startedAt) {
            hospitalPanelServiceRequestSvc.requestFinalGuaranteeLetter(input)
                .success(function (data) {
                    if (isDestroyed)
                        return;

                    if (data && data.isReplyPendingHubConfirmation) {
                        if (Date.now() - startedAt < hubReplyRetryLimitMs) {
                            hubReplyRetryTimer = $timeout(function () {
                                hubReplyRetryTimer = null;
                                submitFinalGuaranteeLetter(input, startedAt);
                            }, hubReplyRetryDelayMs);
                            return;
                        }

                        vm.saving = false;
                        promptReplyNotYetInHub(input);
                        return;
                    }

                    vm.saving = false;
                    abp.notify.info(App.localize("SuccessfullySubmitted"));
                    $state.go('clinic.inpatientDashboard');
                })
                .error(function () {
                    // ABP has already shown the error; just release the form.
                    vm.saving = false;
                });
        }

        // HM-11335: retry window exhausted. Offer to start a fresh window from here, or close and
        // leave the form as it is so the hospital can submit again by hand later.

        function promptReplyNotYetInHub(input) {
            swal({
                title: App.localize('RequestFinalGlReplyNotYetInHubWarning'),
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#1AB394',
                confirmButtonText: App.localize('SubmitAgain'),
                cancelButtonText: App.localize('Close')
            }, function (isConfirm) {
                if (!isConfirm)
                    return;

                // swal's callback runs outside the Angular digest.
                $scope.$apply(function () {
                    vm.saving = true;
                    submitFinalGuaranteeLetter(input, Date.now());
                });
            });
        }

        function downloadDischargeForm(language) {
            vm.exporting++;

            hospitalPanelServiceRequestSvc.getPatientDischargeFormPdf({
                letterNumber: vm.letterNumber,
                doctorName: vm.letter.specialistOrPhysicianName,
                languageCode: language
            }).success(function (data) {
                App.downloadTempFile(data);
            }).finally(function () {
                vm.exporting--;
            });
        }

        /* HM-11000 Unanswered medical query gate */

        function promptUnansweredQueries() {
            var numbers = vm.unansweredQueryNumbers || [];
            var formattedNumbers = _.map(numbers, function (n) {
                return '#' + n;
            }).join(', ');

            var message =
                '<p>' + App.localize('PendingMedicalQueriesWarning', numbers.length, formattedNumbers) + '</p>' +
                '<ol style="text-align: left; display: inline-block; margin: 0;">' +
                '<li>' + App.localize('PendingMedicalQueriesStep1') + '</li>' +
                '<li>' + App.localize('PendingMedicalQueriesStep2') + '</li>' +
                '<li>' + App.localize('PendingMedicalQueriesStep3') + '</li>' +
                '</ol>';

            swal({
                title: App.localize('PendingMedicalQueriesTitle'),
                text: message,
                html: true,
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#1AB394',
                confirmButtonText: App.localize('GoToQueries'),
                cancelButtonText: App.localize('Cancel')
            }, function (isConfirm) {
                if (isConfirm) {
                    goToQueries();
                } else {
                    // [Cancel]: clear any FGL intent; stay on the page with submit disabled.
                    
                    clearFglIntent();
                }
            });
        }

        function goToQueries() {
            setFglIntent();

            // swal's callback runs outside the Angular digest.
            $scope.$apply(function () {
                $state.go('clinic.patientAdmissionDetails', { letterNumber: vm.letterNumber });
            });
        }

        function setFglIntent() {
            try {
                sessionStorage.setItem(fglIntentKey, vm.letterNumber);
            } catch (e) {
                // sessionStorage unavailable (private mode / disabled) — non-fatal.
            }
        }

        function clearFglIntent() {
            try {
                sessionStorage.removeItem(fglIntentKey);
            } catch (e) {
                // sessionStorage unavailable — non-fatal.
            }
        }

        /* Navigation */

        function prevTab() {
            setActiveTab(vm.activeTab - 1);
        }

        function nextTab() {
            if (vm.activeTab === 2) {
                return;
            }

            else if (vm.activeTab === 0 && !App.isFormValid($scope.forms.finalDiagnosisDetails)) {
                return;
            }

            else if (vm.activeTab === 1) {
                vm.invalidAttachment = vm.newAttachments.length < 1;
                vm.invalidChecklist = !App.isFormValid($scope.forms.uploadDocuments) && _.some(vm.letter.documentChecklistItems, function (d) { return d.required && !d.isChecked; });

                if (vm.invalidAttachment || vm.invalidChecklist) {
                    return;
                }
            }

            setActiveTab(vm.activeTab + 1);
        }

        function setActiveTab(tab) {
            if (tab < 0 || tab > 3) return; // Prevent tab out of range.

            vm.activeTab = tab;
        }

        /* End of Navigation */

        init();
    }
})();
